<template>
  <div class="reports__panel--yearmonth">
    <b-field label="År">
      <dropdown :sourceList="options"
                :keyPropertyName="(o) => o.value"
                :displayPropertyName="(o) => o.label"
                @selectionChanged="selectionChanged">
      </dropdown>
    </b-field>

  </div>
</template>

<script>
import Dropdown from '@/components/common/Dropdown.vue';
import moment from 'moment';

export default {
  name: 'reports-panel-year',
  components: { Dropdown },
  props: {
    offsetMonth: {
      type: Number,
      default: 0
    },    
  },
  data: () => ({
    options: []
  }),
  mounted() {
    this.options = this.buildOptions();
  },
  methods: {
    buildOptions() {
      const options = [];
      let date = moment().add(this.offsetMonth, 'months');
      const baseYear = 2021;
      const year = moment().year();
      const idx = (year - baseYear) > 2 ? (year - baseYear) + 1 : 3;
      
      for (let i = 0; i < idx; i++) {
        options.push({
          value: {
            month: 1,
            year: baseYear + i
          },
          label: '' + (baseYear + i),
          isSelected: moment(date).year() - 1 === (baseYear + i)
        });
      }
      return options;
    },
    selectionChanged(value) {
      this.$emit('year', value.year);
    }
  },
  computed: {

  }
}
</script>

<style lang="scss">
.reports__panel--yearmonth {
  .ctrl-button {
    padding-left: 10px !important;
  }
}
</style>